import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';

export default function PrioritySelector({
  priority,
  handlePriorityChange,
}) {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography 
        variant='h6' 
        gutterBottom 
        sx={{ 
          fontWeight: 900,
          color: '#333',
          mb: 2,
          fontSize: '1.1rem'
        }}
      >
        Priority
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
        <FormControl component='fieldset'>
          <RadioGroup
            row
            aria-label='priority'
            name='priority'
            value={priority}
            onChange={handlePriorityChange}
          >
            <FormControlLabel
              value='low'
              control={<Radio />}
              label='Low'
            />
            <FormControlLabel
              value='medium'
              control={<Radio />}
              label='Medium'
            />
            <FormControlLabel
              value='high'
              control={<Radio />}
              label='High'
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  );
} 